<kodit-dropdown
  [options]="items"
  [formCtrl]="tipUplateCtrl"
  (optionChanged)="handleOnItemChange($event)"
></kodit-dropdown>
